import React from 'react';
import {Icon} from 'antd';
import lodashGet from 'lodash/get';

import * as modes from 'constants/modes';
import {getPathToPhoto} from 'utils/index';

import AttachmentItem from './AttachmentItem';
import styles from './photoList.module.scss';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const isUploadedFile = (data: any) => {
    return data && data.file && data.file instanceof File;
};

const getUploadedFileUrl = (file: any): string => {
    return URL.createObjectURL(file);
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const getExistsFileUrl = (file: any) => {
    return getPathToPhoto(file.path);
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const ExistsFile = ({file, index, onDelete}: any) => {
    return <AttachmentItem index={index} fileName={file.name} fileUrl={getExistsFileUrl(file)} onDelete={onDelete} />;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const UploadedFile = ({file, index, onDelete}: any) => {
    return <AttachmentItem index={index} fileName={file.name} fileUrl={getUploadedFileUrl(file)} onDelete={onDelete} />;
};

const ListAttachments = (props: any): JSX.Element => {
    const {mode, form, name, attachmentName, uploadTitle, push, remove} = props;
    const attachments = lodashGet(form.values, name) || [];

    const handleAddNewFile = (file: File): void => {
        const addedAttachments = lodashGet(form.values.addedAttachments, attachmentName) || [];
        if (mode === modes.MODE_UPDATE) {
            form.setFieldValue(`addedAttachments.${attachmentName}`, [...addedAttachments, {file}]);
        }
    };

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const onFileSelect = (event: any) => {
        const file = event.target && event.target.files[0];
        if (file) {
            push({
                file,
                url: getUploadedFileUrl(file),
            });
            handleAddNewFile(file);
        }
    };

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const deleteUploadedFile = (index: any) => {
        remove(index);
    };

    // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
    const deleteExistsFile = (index: any, file: any) => {
        const removedAttachments = lodashGet(form.values.removedAttachments, attachmentName) || [];
        if (mode === modes.MODE_UPDATE) {
            form.setFieldValue(`removedAttachments.${attachmentName}`, [...removedAttachments, {file}]);
        }
        remove(index);
    };
    const photosItems = attachments
        .map((attachmentItem: any, index: any) => {
            if (isUploadedFile(attachmentItem)) {
                return (
                    <UploadedFile
                        key={attachmentItem.file.name}
                        file={attachmentItem.file}
                        index={index}
                        onDelete={() => deleteUploadedFile(index)}
                    />
                );
            }

            return (
                <ExistsFile
                    key={attachmentItem.path}
                    file={attachmentItem}
                    index={index}
                    onDelete={() => deleteExistsFile(index, attachmentItem)}
                />
            );
        })
        .filter(Boolean);

    const filesStyle = form?.errors?.attachments?.[attachmentName] ? `${styles.upload} ${styles.error}` : styles.upload;

    return (
        <div className={filesStyle}>
            {photosItems.length > 0 && <div className="photo-list">{photosItems}</div>}
            <div className="upload-button">
                <Icon type="download" /> {uploadTitle}
                <input onChange={onFileSelect} type="file" />
            </div>
        </div>
    );
};

export default ListAttachments;
